import { __assign } from "tslib";
import React from 'react';
import { SvgIcon } from './internal/SvgIcon';
export var Error = function Error(props) {
  return React.createElement(SvgIcon, __assign({}, props), React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM4.5 6.5C4.22386 6.5 4 6.72386 4 7V9C4 9.27614 4.22386 9.5 4.5 9.5H11.5C11.7761 9.5 12 9.27614 12 9V7C12 6.72386 11.7761 6.5 11.5 6.5H4.5Z",
    clipRule: "evenodd"
  })));
};